import { useEffect } from "react";

const setViewportHeight = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }
  const viewportHeight =
    (window.visualViewport?.height ?? window.innerHeight) * 0.01;
  document.documentElement.style.setProperty(
    "--app-vh",
    `${viewportHeight}px`
  );
};

const useViewportHeight = () => {
  useEffect(() => {
    const handleResize = () => window.requestAnimationFrame(setViewportHeight);

    setViewportHeight();
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);
    window.visualViewport?.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, []);
};

export default useViewportHeight;
